








































import { Component, Vue, Mixins } from 'vue-property-decorator'
import Template from '../../mixins/Template.vue'

@Component
export default class Fullscreen extends Mixins(Template) {
  get block() {
    return this.blocks[0]
  }
}
